// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cdmpxbphrqlxqesjmciu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNkbXB4YnBocnFseHFlc2ptY2l1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMjY0ODksImV4cCI6MjA1ODYwMjQ4OX0.QAwiu8sn2pA0nKo3FNGKIhus5xBFc--yERzY0b5zxVs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);